const e = "_brandColorBaseLine_yrpz3_15", o = {
  brandColorBaseLine: e
};
export {
  e as brandColorBaseLine,
  o as default
};
//# sourceMappingURL=index.es5623.js.map
